const messages = {
  required: 'Enter a value',
  password: 'Password must be 8 characters long',
  alphanumeric: 'Ingrese un valor válido',
  geonumeric: 'Ingrese una coordenada válida',
  minLength: 'La contraseña debe ser de 8 caracteres como mínimo',
  email: 'Email not registered',
  cellphone: 'Ingrese un celular válido',
  text: 'Ingrese un nombre correcto',
  name: 'Ingrese un nombre correcto',
  file: 'Ingrese un archivo válido',
  documentNumber: 'Ingrese un documento válido',
  url: 'Invalid URL',
};

export default messages;



// WEBPACK FOOTER //
// ./src/app/utils/validations/messages.js